import type { ReactNode } from 'react';
import styles from './StatCard.module.css';

interface StatCardProps {
  label: string;
  value: string | number;
  sublabel?: string;
  trend?: {
    direction: 'up' | 'down' | 'flat';
    text: string;
    tone?: 'positive' | 'negative' | 'neutral';
  };
  icon?: ReactNode;
}

const TREND_ARROWS: Record<string, string> = {
  up: '\u2191',
  down: '\u2193',
  flat: '\u2192',
};

export function StatCard({ label, value, sublabel, trend, icon }: StatCardProps) {
  return (
    <div className={styles.card} data-testid="stat-card">
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        {icon && (
          <span className={styles.icon} aria-hidden="true">
            {icon}
          </span>
        )}
      </div>
      <span className={styles.value}>{value}</span>
      {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      {trend && (
        <span className={`${styles.trend} ${styles[trend.tone ?? 'neutral']}`}>
          <span className={styles.arrow} aria-hidden="true">
            {TREND_ARROWS[trend.direction]}
          </span>
          {trend.text}
        </span>
      )}
    </div>
  );
}
